// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3wTfG","rootSuccess":"CompleteLink_rootSuccess__nvxVQ","rootFailure":"CompleteLink_rootFailure__1UWim","isDisabled":"CompleteLink_isDisabled__3iMdR"};